import jsPDF from "jspdf"
import paintTextWrap from "../../plugins/paintTextWrap"

const CHART_WIDTH_S12FN = {
    "0": 6.6875,
    "1": 4.625,
    "2": 6.6875,
    "3": 6.6875,
    "4": 6.890625,
    "5": 6.6875,
    "6": 6.6875,
    "7": 6.46875,
    "8": 6.6875,
    "9": 6.6875,
    "q": 7.265625,
    "w": 8.78125,
    "e": 6.546875,
    "r": 4.28125,
    "t": 3.859375,
    "y": 5.875,
    "u": 6.9375,
    "i": 2.671875,
    "o": 7.28125,
    "p": 7.265625,
    "a": 6.40625,
    "s": 5.046875,
    "d": 7.265625,
    "f": 3.578125,
    "g": 7.265625,
    "h": 6.9375,
    "j": 2.671875,
    "k": 5.765625,
    "l": 2.671875,
    "z": 6.015625,
    "x": 5.46875,
    "c": 5.765625,
    "v": 5.875,
    "b": 7.265625,
    "n": 6.9375,
    "m": 10.65625,
    "Q": 9.78125,
    "W": 11.609375,
    "E": 6.484375,
    "R": 7.203125,
    "T": 6.640625,
    "Y": 7,
    "U": 8.40625,
    "I": 2.953125,
    "O": 9.875,
    "P": 7.0625,
    "A": 8.15625,
    "S": 6.453125,
    "D": 8.734375,
    "F": 6.03125,
    "G": 8.65625,
    "H": 8.78125,
    "J": 4.203125,
    "K": 6.828125,
    "L": 5.9375,
    "Z": 7.390625,
    "X": 7.296875,
    "C": 8.0625,
    "V": 7.828125,
    "B": 7.0625,
    "N": 9.1875,
    "M": 10.796875,
    "-": 5.15625,
    "=": 8.421875,
    "[": 3.65625,
    " ": 3.5625,
    "]": 3.65625,
    ";": 2.890625,
    "'": 2.78125,
    ",": 2.890625,
    ".": 2.890625,
    "·": 2.890625,
    "/": 4.75,
    "!": 3.6875,
    "@": 12.234375,
    "#": 7.828125,
    "$": 6.6875,
    "%": 10.171875,
    "^": 8.421875,
    "&": 9.03125,
    "*": 5.265625,
    "(": 3.65625,
    ")": 3.65625,
    "_": 5.390625,
    "+": 8.421875,
    "{": 3.65625,
    "}": 3.65625,
    ":": 2.890625,
    "\"": 4.34375,
    "&lt;": 8.421875,
    "&gt;": 8.421875,
    "?": 5.578125,
    "~": 8.421875,
    "`": 3.21875
}

const CHART_WIDTH_S14FN = {
    "0": 7.796875,
    "1": 5.390625,
    "2": 7.796875,
    "3": 7.796875,
    "4": 8.03125,
    "5": 7.796875,
    "6": 7.796875,
    "7": 7.546875,
    "8": 7.796875,
    "9": 7.796875,
    "q": 8.484375,
    "w": 10.234375,
    "e": 7.640625,
    "r": 5,
    "t": 4.5,
    "y": 6.859375,
    "u": 8.09375,
    "i": 3.109375,
    "o": 8.484375,
    "p": 8.484375,
    "a": 7.484375,
    "s": 5.875,
    "d": 8.484375,
    "f": 4.171875,
    "g": 8.484375,
    "h": 8.09375,
    "j": 3.109375,
    "k": 6.71875,
    "l": 3.109375,
    "z": 7.015625,
    "x": 6.375,
    "c": 6.71875,
    "v": 6.859375,
    "b": 8.484375,
    "n": 8.09375,
    "m": 12.4375,
    "Q": 11.40625,
    "W": 13.546875,
    "E": 7.5625,
    "R": 8.40625,
    "T": 7.734375,
    "Y": 8.171875,
    "U": 9.796875,
    "I": 3.453125,
    "O": 11.515625,
    "P": 8.234375,
    "A": 9.515625,
    "S": 7.515625,
    "D": 10.1875,
    "F": 7.03125,
    "G": 10.109375,
    "H": 10.234375,
    "J": 4.90625,
    "K": 7.96875,
    "L": 6.9375,
    "Z": 8.625,
    "X": 8.515625,
    "C": 9.40625,
    "V": 9.140625,
    "B": 8.234375,
    "N": 10.71875,
    "M": 12.59375,
    "-": 6.015625,
    "=": 9.828125,
    "[": 4.265625,
    " ": 4.15625,
    "]": 4.265625,
    ";": 3.359375,
    "'": 3.234375,
    ",": 3.359375,
    ".": 3.359375,
    "·": 3.359375,
    "/": 5.546875,
    "!": 4.3125,
    "@": 14.28125,
    "#": 9.140625,
    "$": 7.796875,
    "%": 11.859375,
    "^": 9.828125,
    "&": 10.546875,
    "*": 6.140625,
    "(": 4.265625,
    ")": 4.265625,
    "_": 6.28125,
    "+": 9.828125,
    "{": 4.265625,
    "}": 4.265625,
    ":": 3.359375,
    "\"": 5.078125,
    "&lt;": 9.828125,
    "&gt;": 9.828125,
    "?": 6.515625,
    "~": 9.828125,
    "`": 3.765625
}

const CHART_WIDTH_S16FN = {
    "0": 8.90625,
    "1": 6.15625,
    "2": 8.90625,
    "3": 8.90625,
    "4": 9.171875,
    "5": 8.90625,
    "6": 8.90625,
    "7": 8.625,
    "8": 8.90625,
    "9": 8.90625,
    "q": 9.6875,
    "w": 11.703125,
    "e": 8.734375,
    "r": 5.703125,
    "t": 5.140625,
    "y": 7.828125,
    "u": 9.25,
    "i": 3.546875,
    "o": 9.703125,
    "p": 9.6875,
    "a": 8.546875,
    "s": 6.71875,
    "d": 9.6875,
    "f": 4.765625,
    "g": 9.6875,
    "h": 9.25,
    "j": 3.546875,
    "k": 7.671875,
    "l": 3.546875,
    "z": 8.015625,
    "x": 7.28125,
    "c": 7.671875,
    "v": 7.828125,
    "b": 9.6875,
    "n": 9.25,
    "m": 14.203125,
    "Q": 13.03125,
    "W": 15.46875,
    "E": 8.640625,
    "R": 9.59375,
    "T": 8.84375,
    "Y": 9.328125,
    "U": 11.203125,
    "I": 3.9375,
    "O": 13.15625,
    "P": 9.40625,
    "A": 10.875,
    "S": 8.59375,
    "D": 11.640625,
    "F": 8.03125,
    "G": 11.546875,
    "H": 11.703125,
    "J": 5.609375,
    "K": 9.109375,
    "L": 7.921875,
    "Z": 9.84375,
    "X": 9.734375,
    "C": 10.734375,
    "V": 10.4375,
    "B": 9.40625,
    "N": 12.25,
    "M": 14.390625,
    "-": 6.875,
    "=": 11.234375,
    "[": 4.875,
    " ": 4.734375,
    "]": 4.875,
    ";": 3.84375,
    "'": 3.703125,
    ",": 3.84375,
    ".": 3.84375,
    "·": 3.84375,
    "/": 6.328125,
    "!": 4.921875,
    "@": 16.3125,
    "#": 10.4375,
    "$": 8.90625,
    "%": 13.546875,
    "^": 11.234375,
    "&": 12.046875,
    "*": 7.015625,
    "(": 4.875,
    ")": 4.875,
    "_": 7.171875,
    "+": 11.234375,
    "{": 4.875,
    "}": 4.875,
    ":": 3.84375,
    "\"": 5.796875,
    "&lt;": 11.234375,
    "&gt;": 11.234375,
    "?": 7.4375,
    "~": 11.234375,
    "`": 4.296875
}

const CHART_WIDTH_S12F6 = {
    "0": 7.40625,
    "1": 7.40625,
    "2": 7.40625,
    "3": 7.40625,
    "4": 7.40625,
    "5": 7.40625,
    "6": 7.40625,
    "7": 7.40625,
    "8": 7.40625,
    "9": 7.40625,
    "q": 7.984375,
    "w": 10.21875,
    "e": 6.984375,
    "r": 5.09375,
    "t": 4.96875,
    "y": 6.890625,
    "u": 7.78125,
    "i": 3.5625,
    "o": 7.890625,
    "p": 8,
    "a": 6.9375,
    "s": 5.9375,
    "d": 7.984375,
    "f": 4.875,
    "g": 7.984375,
    "h": 7.75,
    "j": 3.625,
    "k": 7.15625,
    "l": 3.5625,
    "z": 6.171875,
    "x": 7.03125,
    "c": 6.203125,
    "v": 6.9375,
    "b": 8,
    "n": 7.78125,
    "m": 11.796875,
    "Q": 9.828125,
    "W": 12.921875,
    "E": 6.875,
    "R": 8.390625,
    "T": 7.515625,
    "Y": 7.78125,
    "U": 9.328125,
    "I": 4.03125,
    "O": 9.828125,
    "P": 7.890625,
    "A": 9.03125,
    "S": 7.21875,
    "D": 9.5,
    "F": 6.703125,
    "G": 9.1875,
    "H": 9.859375,
    "J": 5.65625,
    "K": 8.328125,
    "L": 6.5625,
    "Z": 7.8125,
    "X": 8.40625,
    "C": 8.09375,
    "V": 8.578125,
    "B": 8.203125,
    "N": 10.1875,
    "M": 12.34375,
    "-": 5.25,
    "=": 9.140625,
    "[": 4.6875,
    " ": 3.578125,
    "]": 4.6875,
    ";": 3.4375,
    "'": 3.703125,
    ",": 3.4375,
    ".": 3.4375,
    "·": 5.28125,
    "/": 5.671875,
    "!": 4.1875,
    "@": 12.359375,
    "#": 7.6875,
    "$": 7.40625,
    "%": 11.1875,
    "^": 9.140625,
    "&": 10.9375,
    "*": 5.859375,
    "(": 4.6875,
    ")": 4.6875,
    "_": 5.390625,
    "+": 9.140625,
    "{": 4.6875,
    "}": 4.6875,
    ":": 3.4375,
    "\"": 6.265625,
    "&lt;": 9.140625,
    "&gt;": 9.140625,
    "?": 5.703125,
    "~": 9.140625,
    "`": 4.015625
}

const CHART_WIDTH_S14F6 = {
    "0": 8.640625,
    "1": 8.640625,
    "2": 8.640625,
    "3": 8.640625,
    "4": 8.640625,
    "5": 8.640625,
    "6": 8.640625,
    "7": 8.640625,
    "8": 8.640625,
    "9": 8.640625,
    "q": 9.3125,
    "w": 11.921875,
    "e": 8.15625,
    "r": 5.9375,
    "t": 5.796875,
    "y": 8.046875,
    "u": 9.078125,
    "i": 4.15625,
    "o": 9.203125,
    "p": 9.328125,
    "a": 8.09375,
    "s": 6.921875,
    "d": 9.3125,
    "f": 5.6875,
    "g": 9.3125,
    "h": 9.046875,
    "j": 4.234375,
    "k": 8.359375,
    "l": 4.15625,
    "z": 7.203125,
    "x": 8.203125,
    "c": 7.234375,
    "v": 8.09375,
    "b": 9.328125,
    "n": 9.078125,
    "m": 13.75,
    "Q": 11.46875,
    "W": 15.078125,
    "E": 8.015625,
    "R": 9.78125,
    "T": 8.765625,
    "Y": 9.078125,
    "U": 10.875,
    "I": 4.703125,
    "O": 11.46875,
    "P": 9.203125,
    "A": 10.53125,
    "S": 8.421875,
    "D": 11.09375,
    "F": 7.828125,
    "G": 10.71875,
    "H": 11.5,
    "J": 6.59375,
    "K": 9.703125,
    "L": 7.65625,
    "Z": 9.109375,
    "X": 9.8125,
    "C": 9.4375,
    "V": 10.015625,
    "B": 9.578125,
    "N": 11.875,
    "M": 14.40625,
    "-": 6.125,
    "=": 10.671875,
    "[": 5.46875,
    " ": 4.171875,
    "]": 5.46875,
    ";": 4,
    "'": 4.328125,
    ",": 4,
    ".": 4,
    "·": 6.15625,
    "/": 6.625,
    "!": 4.890625,
    "@": 14.421875,
    "#": 8.96875,
    "$": 8.640625,
    "%": 13.046875,
    "^": 10.671875,
    "&": 12.765625,
    "*": 6.828125,
    "(": 5.46875,
    ")": 5.46875,
    "_": 6.28125,
    "+": 10.671875,
    "{": 5.46875,
    "}": 5.46875,
    ":": 4,
    "\"": 7.296875,
    "&lt;": 10.671875,
    "&gt;": 10.671875,
    "?": 6.640625,
    "~": 10.671875,
    "`": 4.671875
}

const CHART_WIDTH_S16F6 = {
    "0": 9.875,
    "1": 9.875,
    "2": 9.875,
    "3": 9.875,
    "4": 9.875,
    "5": 9.875,
    "6": 9.875,
    "7": 9.875,
    "8": 9.875,
    "9": 9.875,
    "q": 10.640625,
    "w": 13.625,
    "e": 9.3125,
    "r": 6.78125,
    "t": 6.625,
    "y": 9.1875,
    "u": 10.375,
    "i": 4.734375,
    "o": 10.515625,
    "p": 10.65625,
    "a": 9.25,
    "s": 7.90625,
    "d": 10.640625,
    "f": 6.484375,
    "g": 10.640625,
    "h": 10.328125,
    "j": 4.828125,
    "k": 9.546875,
    "l": 4.734375,
    "z": 8.21875,
    "x": 9.359375,
    "c": 8.265625,
    "v": 9.234375,
    "b": 10.65625,
    "n": 10.375,
    "m": 15.71875,
    "Q": 13.09375,
    "W": 17.21875,
    "E": 9.15625,
    "R": 11.171875,
    "T": 10.015625,
    "Y": 10.375,
    "U": 12.421875,
    "I": 5.375,
    "O": 13.09375,
    "P": 10.515625,
    "A": 12.03125,
    "S": 9.625,
    "D": 12.671875,
    "F": 8.9375,
    "G": 12.25,
    "H": 13.140625,
    "J": 7.53125,
    "K": 11.09375,
    "L": 8.75,
    "Z": 10.40625,
    "X": 11.203125,
    "C": 10.78125,
    "V": 11.4375,
    "B": 10.9375,
    "N": 13.578125,
    "M": 16.453125,
    "-": 6.984375,
    "=": 12.1875,
    "[": 6.234375,
    " ": 4.765625,
    "]": 6.234375,
    ";": 4.578125,
    "'": 4.9375,
    ",": 4.578125,
    ".": 4.578125,
    "·": 7.03125,
    "/": 7.5625,
    "!": 5.578125,
    "@": 16.484375,
    "#": 10.25,
    "$": 9.875,
    "%": 14.90625,
    "^": 12.1875,
    "&": 14.578125,
    "*": 7.796875,
    "(": 6.234375,
    ")": 6.234375,
    "_": 7.171875,
    "+": 12.1875,
    "{": 6.234375,
    "}": 6.234375,
    ":": 4.578125,
    "\"": 8.34375,
    "&lt;": 12.1875,
    "&gt;": 12.1875,
    "?": 7.59375,
    "~": 12.1875,
    "`": 5.34375
}

export default class CanvasChart {
    constructor(config) {
        this.config = config

        this.MAX_SIZE = 32767 - 1

        this.FONT_HEIGHT_MAP = {
            12: 16,
            14: 19,
            16: 21
        }

        this.getCanvasSize()

        return this.beforePaint()
    }

    getCanvasSize() {
        const { maxLoc, minLoc, baseCardSize: { w, h } } = this.config

        const cw = maxLoc.x - minLoc.x + w + h
        const ch = maxLoc.y - minLoc.y + h + w

        this.canvasWidth = Math.max(960, cw)
        this.canvasHeight = Math.max(480, ch)

        this.scale = 1

        // this.ratio = Math.max(getRatio(), 1)
        this.ratio = 2

        if ((this.canvasWidth * this.ratio) >= this.MAX_SIZE) {
            this.scale = Math.ceil((this.canvasWidth * this.ratio) / this.MAX_SIZE * 10000) / 10000
        }
    }

    beforePaint() {
        console.log(this.canvasWidth, this.canvasHeight, this.MAX_SIZE);
        if (Math.max(this.canvasWidth, this.canvasHeight) > this.MAX_SIZE) {
            console.error("导出图片超出浏览器规定最大尺寸");
            return Promise.reject()
        } else {
            this.getCanvasOffset()

            return this.preLoadImg().then(() => {
                this.initPaint()
                return this
            })
        }
    }

    getCanvasOffset() {
        const { maxLoc, minLoc, baseCardSize: { w, h } } = this.config

        this.offsetX = 0
        this.offsetY = 0

        switch (this.config.direction) {
            case 1:
                this.offsetX = -minLoc.x + Math.max(w, h) + Math.min(w, h) / 2
                break;
            case 2:
                this.offsetX = -minLoc.x + Math.max(w, h) + Math.min(w, h) / 2
                this.offsetY = -minLoc.y + (h + w) / 2
                break;
            case 3:
                this.offsetX = -minLoc.x + Math.max(w, h) + Math.min(w, h) / 2
                this.offsetY = -minLoc.y + (h + w) / 2
                break;
            case 4:
                this.offsetX = -minLoc.x + Math.max(w, h) + Math.min(w, h) / 2
                this.offsetY = -minLoc.y + (h + w) / 2
                break;
        }
    }

    preLoadImg() {
        let imgLoadList = []

        this.imageMap = {}
        this.config.nodeList.map(node => {
            let cardModel = this.config.cardModelMap[node.cardModel] || []
            cardModel.map((card, index) => {
                if (card.tag === "img" || card.tag === "icon") {
                    let id = ""
                    let src = ""
                    if (card.tag === "img") {
                        id = "img" + node.id + "_" + index
                        src = resolveParams(card.url, this.DEFAULT_IMG, node.data)
                    }
                    if (card.tag === "icon") {
                        id = card.id
                        src = card.src
                    }

                    if (this.imageMap[id]) {
                        return
                    } else {
                        imgLoadList.push(new Promise((resolve) => {
                            const img = new Image()

                            img.crossOrigin = 'anonymous';
                            img.src = src + `?timestamp=${Date.now() + parseInt(Math.random() * 99999999)}`
                            img.onload = () => {
                                this.imageMap[id] = img
                                resolve()
                            }
                        }))
                    }

                }
            })
        })

        return Promise.all(imgLoadList)
    }

    initPaint() {
        this.initCanvas()

        this.config.linkList.map(path => this.paintPath(path))
        this.config.nodeList.map(node => this.paintNode(node))
    }

    initCanvas() {
        // canvas实际的尺寸
        const canvasW = this.canvasWidth / this.scale
        const canvasH = this.canvasHeight / this.scale

        this.canvas = document.createElement("canvas")
        this.ctx = this.canvas.getContext("2d");

        this.canvas.width = canvasW * this.ratio
        this.canvas.height = canvasH * this.ratio
        this.canvas.style.width = canvasW + "px"
        this.canvas.style.height = canvasH + "px"

        this.ctx.fillStyle = "#fff"
        // 绘制大背景
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        // 设置ratio
        this.ctx.setTransform(this.ratio, 0, 0, this.ratio, 0, 0);

        // document.body.append(this.canvas)
    }

    paintPath(path) {
        const pots = this.getPathPots(path)

        //开始绘制
        this.ctx.beginPath();
        // 设置颜色
        this.ctx.strokeStyle = "#ccc";

        pots.map((p, i) => {
            // 最终绘制的时候，处理缩放倍数
            if (i === 0) {
                this.ctx.moveTo(p.x / this.scale, p.y / this.scale);
            } else {
                this.ctx.lineTo(p.x / this.scale, p.y / this.scale);
            }
        })

        this.ctx.stroke();
    }

    getPathPots(path) {
        const sourceNode = path.source
        const targetNode = path.target

        let sourceLoadType = sourceNode.childLoadType
        const targetIsLeaf = targetNode.isLeaf

        const sourceRect = sourceNode.cardSize
        const targetRect = targetNode.cardSize

        const source = this.getMidLoc(sourceNode)
        const target = this.getMidLoc(targetNode)

        if (this.config.rotateLevel > -1) {
            sourceLoadType = 0
        }

        switch (this.config.direction) {
            case 1:
                return getDirction1(source, target, sourceRect, targetRect, sourceLoadType, targetIsLeaf)
            case 2:
                return getDirction2(source, target, sourceRect, targetRect)
            case 3:
                return getDirction3(source, target, sourceRect, targetRect, sourceLoadType, targetIsLeaf)
            case 4:
                return getDirction4(source, target, sourceRect, targetRect)
        }
    }

    getMidLoc(node) {
        const [ptX, ptY] = this.getNodeRealLoc(node)

        const midx = ptX + node.cardSize.w / 2
        const midy = ptY + node.cardSize.h / 2

        return {
            x: midx,
            y: midy
        }
    }

    paintNode(node) {
        // 卡片绘制的起点，左上角
        const [ptX, ptY] = this.getNodeRealLoc(node)

        this.paintWrapper(node, ptX, ptY)

        const cardModels = this.config.cardModelMap[node.cardModel] || []

        cardModels.map((card, index) => {
            const ix = ptX + card.x
            const iy = ptY + card.y
            switch (card.tag) {
                case "rect":
                    this.paintRect(card, node, ix, iy)
                    break;
                case "img":
                    this.paintImg(card, this.imageMap["img" + node.id + "_" + index], ix, iy)
                    break;
                case "text":
                    this.paintText(card, node, ptX, ptY)
                    break;
                case "icon":
                    this.paintIcon(card, ix, iy)
                    break;
            }
        })
    }

    getNodeRealLoc(node) {
        let currOffsetX = - node.cardSize.w
        let currOffsetY = 0
        if (this.config.rotateLevel > -1 && node.level >= this.config.rotateLevel) {
            currOffsetY = - this.config.baseCardSize.h / 2
        } else {
            currOffsetY = - node.cardSize.h / 2
        }

        return [node.x + currOffsetX + this.offsetX, node.y + currOffsetY + this.offsetY]
    }

    paintWrapper(node, ptX, ptY) {
        const x = ptX / this.scale
        const y = ptY / this.scale
        const w = node.cardSize.w / this.scale
        const h = node.cardSize.h / this.scale

        this.ctx.fillStyle = node.cardStyle.background
        this.ctx.fillRect(x, y, w, h);
        this.ctx.strokeStyle = node.cardStyle.border
        this.ctx.strokeRect(x, y, w, h);
    }

    paintRect(card, node, x, y) {
        const fill = resolveParams(card.fill, "#fff", node.data)
        const ix = x / this.scale
        const iy = y / this.scale
        const w = card.w / this.scale
        const h = card.h / this.scale

        if (card.rx && card.rx > 0) {
            this.paintRoundRect(ix, iy, w, h, card.rx, fill);
        } else {
            this.ctx.fillStyle = fill
            this.ctx.fillRect(ix, iy, w, h);
        }
    }

    paintRoundRect(x, y, w, h, r, fill) {
        if (w < 2 * r) { r = w / 2; }
        if (h < 2 * r) { r = h / 2; }
        //开始绘制
        this.ctx.beginPath();

        this.ctx.moveTo(x + r, y);
        this.ctx.arcTo(x + w, y, x + w, y + h, r);
        this.ctx.arcTo(x + w, y + h, x, y + h, r);
        this.ctx.arcTo(x, y + h, x, y, r);
        this.ctx.arcTo(x, y, x + w, y, r);
        this.ctx.closePath();

        // 设置颜色
        this.ctx.fillStyle = fill;
        this.ctx.fill()
    }

    paintImg(card, img, x, y) {
        let w = card.w
        let h = card.h

        const size = Math.min(w, h)

        switch (card.textAnchor) {
            case "start":
                break;
            case "middle":
                x += (w - size) / 2
                break;
            case "end":
                x += (w - size)
                break;
        }

        y += (h - size) / 2

        this.ctx.drawImage(img, x / this.scale, y / this.scale, size / this.scale, size / this.scale);
    }

    // 显示范围内文字
    paintText(card, node, x, y) {
        const textInfo = resolveParams(card.text, "", node.data).reduce((t1, t2) => t1 + t2, "")
        const fontSize = card.fontSize / this.scale
        const fontWeight = card.fontWeight
        const textList = paintTextWrap({
            ...card,
            fontHeight: this.FONT_HEIGHT_MAP[card.fontSize],
            texts: textInfo
        }).textDoms

        this.ctx.fillStyle = this.getColor(card, node)
        this.ctx.font = fontWeight + " " + fontSize + "px Microsoft YaHei, PingFangSC-Regular, Helvetica Neue, Helvetica, Arial, Hiragino Sans GB, WenQuanYi Micro Hei, sans-serif"

        card.wMode = card.wMode || "lr"
        switch (card.wMode) {
            case "lr":
                textList.map((textObj) => {
                    const { text, len, x: rx, y: ry } = textObj

                    this.ctx.fillText(text, (x + rx) / this.scale, (y + ry) / this.scale, len / this.scale);
                })
                break;
            case "tb":
                textList.map((textObj) => {
                    const { text: textstr, x: rx, y: ry } = textObj

                    let paintX = x + rx - fontSize / 2
                    let paintY = y + ry

                    for (let iy = 0; iy < textstr.length; iy++) {
                        const currWidth = this.getChartWidth(textstr[iy], fontSize, fontWeight)

                        if (textstr.charCodeAt(iy) > 255) {
                            this.ctx.fillText(textstr[iy], paintX, paintY + currWidth);
                        } else {
                            this.ctx.translate(paintX, paintY)
                            this.ctx.rotate((Math.PI / 180) * 90);
                            this.ctx.translate(-paintX, -paintY)
                            this.ctx.fillText(textstr[iy], paintX, paintY);
                        }

                        paintY += currWidth

                        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                    }
                })
                break;
        }

    }

    // 显示全部文字
    paintText_fullText(card, node, x, y) {
        const textInfo = resolveParams(card.text, "", node.data).reduce((t1, t2) => t1 + t2, "")
        const fontSize = card.fontSize / this.scale
        const fontWeight = card.fontWeight
        const fontHeight = this.FONT_HEIGHT_MAP[card.fontSize] / this.scale

        let fontSizeWidth = 0
        let offsetX = 0

        const textConfig = paintTextWrap({
            ...card,
            fontHeight: this.FONT_HEIGHT_MAP[card.fontSize],
            texts: textInfo
        })

        let textList = textConfig.textDoms

        this.ctx.fillStyle = this.getColor(card, node)
        this.ctx.font = fontWeight + " " + fontSize + "px Microsoft YaHei, PingFangSC-Regular, Helvetica Neue, Helvetica, Arial, Hiragino Sans GB, WenQuanYi Micro Hei, sans-serif"

        card.wMode = card.wMode || "lr"
        switch (card.wMode) {
            case "lr":
                // textList = this.getTextList(textInfo, fontSize, fontWeight, card.w)

                textList.map((textObj, i) => {
                    const { text: textstr, len } = textObj

                    let offsetx = 0

                    // if (card.textAnchor === "start") {}
                    if (card.textAnchor === "middle") {
                        offsetx = (card.w - len) / 2
                    }
                    if (card.textAnchor === "end") {
                        offsetx = card.w - len
                    }

                    let offsetY = - fontHeight

                    // if (card.valign === "top") {}
                    if (card.valign === "center") {
                        offsetY = (card.h - fontHeight) / 2
                    }
                    if (card.valign === "bottom") {
                        offsetY = card.h - fontHeight
                    }

                    this.ctx.fillText(textstr, x + offsetx, y + (i + 1) * fontSize + offsetY, card.w);
                })
                break;
            case "tb":
                fontSizeWidth = fontSize + 1

                // textList = this.getTextList(textInfo, fontSize, fontWeight, card.h)

                offsetX = (card.w - textList.length * fontSizeWidth) / 2

                textList.map((textObj, ix) => {
                    const { text: textstr, } = textObj
                    const offsetY = 0

                    // if (card.textAnchor === "start") {
                    // }
                    // if (card.textAnchor === "middle") {
                    //     offsetY = (card.h - len) / 2
                    // }
                    // if (card.textAnchor === "end") {
                    //     offsetY = (card.h - len)
                    // }

                    let paintX = x + ix * fontSizeWidth + offsetX
                    let paintY = y + offsetY

                    for (let iy = 0; iy < textstr.length; iy++) {
                        const currWidth = this.getChartWidth(textstr[iy], fontSize, fontWeight)

                        if (textstr.charCodeAt(iy) > 255) {
                            this.ctx.fillText(textstr[iy], paintX, paintY + currWidth);

                        } else {
                            this.ctx.translate(paintX, paintY)
                            this.ctx.rotate((Math.PI / 180) * 90);
                            this.ctx.translate(-paintX, -paintY)
                            this.ctx.fillText(textstr[iy], paintX, paintY);
                        }

                        paintY += currWidth

                        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                    }
                })
                break;
        }

    }

    paintIcon(card, ix, iy) {
        // const icon = document.getElementsByClassName(card.class)[0].textContent
        // const fontSize = card.fontSize / this.scale

        // setTimeout(() => {
        //     this.ctx.fillStyle = card.fill
        //     this.ctx.font = fontSize + "px " + card.fontFamily
        //     this.ctx.fillText(icon, (ix + card.fontSize) / this.scale, iy / this.scale)
        // }, 200);


        const size = card.fontSize

        ix += (card.w - size) / 2
        iy += (card.h - size) / 2

        this.ctx.drawImage(this.imageMap[card.id], ix / this.scale, iy / this.scale, size / this.scale, size / this.scale);
    }

    downPng(name = "组织架构图") {
        downloadFile(name, this.canvas.toDataURL())
    }

    downPdf(name = "组织架构图") {
        let width = this.canvasWidth
        let height = this.canvasHeight

        const doc = new jsPDF(width > height ? "l" : "p", "px", [width, height]);
        const imageData = this.canvas.toDataURL();
        doc.addImage(imageData, 'pdf', 0, 0, width, height);
        doc.save(name + '.pdf');
    }

    getColor = function (card, node) {
        let color = "#212121"
        if (typeof card.color === "function") {
            color = card.color(node.data)
        } else {
            color = card.color
        }
        return color
    }

    getTextList(textInfo, fontSize, fontWeight, lineWidth) {
        const textList = []

        let currLineWidth = 0
        let currText = ""

        for (let i = 0; i < textInfo.length; i++) {
            currLineWidth += this.getChartWidth(textInfo[i], fontSize, fontWeight)

            currText += textInfo[i]

            if (currLineWidth + this.getChartWidth(textInfo[i + 1] || "", fontSize, fontWeight) > lineWidth) {
                textList.push({
                    text: currText,
                    len: currLineWidth
                })

                currText = ""
                currLineWidth = 0
            }

            if (i === textInfo.length - 1) {
                if (currText.length > 0) {
                    textList.push({
                        text: currText,
                        len: currLineWidth
                    })

                    currText = ""
                    currLineWidth = 0
                }
            }
        }

        return textList
    }

    getChartWidth(chartCode = "", fontSize = 14, fontWeight = 500) {
        let width = 0

        if (chartCode.charCodeAt(0) > 255) {
            width = fontSize
        } else {
            let cwType = "S" + fontSize + "F" + (fontWeight >= 600 ? "6" : "N")

            switch (cwType) {
                case "S12FN":
                    width = CHART_WIDTH_S12FN[chartCode]

                    break;
                case "S14FN":
                    width = CHART_WIDTH_S14FN[chartCode]
                    break;
                case "S16FN":
                    width = CHART_WIDTH_S16FN[chartCode]
                    break;
                case "S12F6":
                    width = CHART_WIDTH_S12F6[chartCode]
                    break;
                case "S14F6":
                    width = CHART_WIDTH_S14F6[chartCode]
                    break;
                case "S16F6":
                    width = CHART_WIDTH_S16F6[chartCode]
                    break;
            }
        }

        return width
    }
}

function getDirction1(source, target, sourceRect, targetRect, sourceLoadType, isLeaf) {
    let pots = []

    // 起点终点都在卡片中央
    // x,y位于卡片中央

    //起点
    if (sourceLoadType === 1) {
        pots.push({
            x: source.x - sourceRect.w / 2 + sourceRect.xSpace / 4,
            y: source.y + sourceRect.h / 2
        })
    } else {
        pots.push({
            x: source.x,
            y: source.y + sourceRect.h / 2
        })
    }

    //拐点
    if (isLeaf) {
        pots.push({
            x: source.x,
            y: target.y
        })
    } else {
        switch (sourceLoadType) {
            case 1:
                pots.push({
                    x: source.x - sourceRect.w / 2 + sourceRect.xSpace / 4,
                    y: target.y
                })
                break;
            case 2:
                pots.push({
                    x: source.x,
                    y: target.y
                })
                break;
            default:

                pots.push({
                    x: source.x,
                    y: target.y - targetRect.h / 2 - targetRect.ySpace / 2
                })

                pots.push({
                    x: target.x,
                    y: target.y - targetRect.h / 2 - targetRect.ySpace / 2
                })
        }
    }

    //终点
    if (isLeaf || sourceLoadType === 2) {
        pots.push({
            x: target.x,
            y: target.y
        })
    } else if (sourceLoadType === 1) {
        pots.push({
            x: target.x - targetRect.w / 2,
            y: target.y
        })
    } else {
        pots.push({
            x: target.x,
            y: target.y - targetRect.h / 2
        })
    }

    return pots
}

function getDirction2(source, target, sourceRect, targetRect) {
    let pots = []

    //起点
    pots.push({
        x: source.x + sourceRect.w / 2,
        y: source.y
    })

    //拐点
    pots.push({
        x: target.x - targetRect.w / 2 - targetRect.xSpace / 2,
        y: source.y
    })

    pots.push({
        x: target.x - targetRect.w / 2 - targetRect.xSpace / 2,
        y: target.y
    })

    //终点
    pots.push({
        x: target.x - targetRect.w / 2,
        y: target.y
    })

    return pots
}

function getDirction3(source, target, sourceRect, targetRect, sourceLoadType, isLeaf) {
    let pots = []

    // 起点终点都在卡片中央
    // x,y位于卡片中央

    //起点
    if (sourceLoadType === 1) {
        pots.push({
            x: source.x - sourceRect.w / 2 + sourceRect.xSpace / 4,
            y: source.y - sourceRect.h / 2
        })
    } else {
        pots.push({
            x: source.x,
            y: source.y - sourceRect.h / 2
        })
    }

    //拐点
    if (isLeaf) {
        pots.push({
            x: source.x,
            y: target.y
        })
    } else {
        switch (sourceLoadType) {
            case 1:
                pots.push({
                    x: source.x - sourceRect.w / 2 + sourceRect.xSpace / 4,
                    y: target.y
                })
                break;
            case 2:
                pots.push({
                    x: source.x,
                    y: target.y
                })
                break;
            default:

                pots.push({
                    x: source.x,
                    y: target.y + targetRect.h / 2 + targetRect.ySpace / 2
                })

                pots.push({
                    x: target.x,
                    y: target.y + targetRect.h / 2 + targetRect.ySpace / 2
                })
        }
    }

    //终点
    if (isLeaf || sourceLoadType === 2) {
        pots.push({
            x: target.x,
            y: target.y
        })
    } else if (sourceLoadType === 1) {
        pots.push({
            x: target.x - targetRect.w / 2,
            y: target.y
        })
    } else {
        pots.push({
            x: target.x,
            y: target.y + targetRect.h / 2
        })
    }

    return pots
}

function getDirction4(source, target, sourceRect, targetRect) {
    let pots = []

    //起点
    pots.push({
        x: source.x - sourceRect.w / 2,
        y: source.y
    })

    //拐点
    pots.push({
        x: target.x + targetRect.w / 2 + targetRect.xSpace / 2,
        y: source.y
    })

    pots.push({
        x: target.x + targetRect.w / 2 + targetRect.xSpace / 2,
        y: target.y
    })

    //终点
    pots.push({
        x: target.x + targetRect.w / 2,
        y: target.y
    })

    return pots
}

function getRatio() {
    const c = document.createElement("canvas"),
        ctx = c.getContext("2d"),
        dpr = window.devicePixelRatio || 1,
        bsr = ctx['webkitBackingStorePixelRatio'] ||
            ctx['mozBackingStorePixelRatio'] ||
            ctx['msBackingStorePixelRatio'] ||
            ctx['oBackingStorePixelRatio'] ||
            ctx['backingStorePixelRatio'] || 1;

    return dpr / bsr;
}

function downloadFile(fileName, content) {
    if (myBrowser() === "IE") {
        //支持IE11
        var blob = base64ToBlob(content);
        window.navigator.msSaveBlob(blob, fileName);
    } else {
        const alink = document.createElement("a");

        alink.href = content

        alink.download = fileName + ".png";

        alink.click();
    }
}

function base64ToBlob(code) {
    let parts = code.split(';base64,');
    let contentType = parts[0].split(':')[1];
    let raw = window.atob(parts[1]);
    let rawLength = raw.length;

    let uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], {
        type: contentType
    });
}

function resolveParams(param, defaultVal, data) {
    let res = defaultVal
    if (typeof param === "function") {
        res = param(data)
    } else {
        res = param
    }
    return res
}

function myBrowser() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isOpera = userAgent.indexOf("OPR") > -1; if (isOpera) { return "Opera" }; //判断是否Opera浏览器 OPR/43.0.2442.991

    //if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) { return "IE"; }; //判断是否IE浏览器 

    if (userAgent.indexOf("Firefox") > -1) { return "FF"; } //判断是否Firefox浏览器  Firefox/51.0
    if (userAgent.indexOf("Trident") > -1) { return "IE"; } //判断是否IE浏览器  Trident/7.0; rv:11.0
    if (userAgent.indexOf("Edge") > -1) { return "Edge"; } //判断是否Edge浏览器  Edge/14.14393
    if (userAgent.indexOf("Chrome") > -1) { return "Chrome"; }// Chrome/56.0.2924.87
    if (userAgent.indexOf("Safari") > -1) { return "Safari"; } //判断是否Safari浏览器 AppleWebKit/534.57.2 Version/5.1.7 Safari/534.57.2
}